import React from 'react';
import { useHistory } from 'react-router-dom';
import ListItem from '../../../../../components/lists/list-item/list-item';
import { DataVariant, ListItemData } from '../../../../../components/lists/list-item/types';
import { formatDate } from '../../../../../helpers/date-formatters';
import { formatNumber } from '../../../../../helpers/number-formatters';
import {
  ExchangeOrderListItem as ListItemDataInput,
  ExchangeRateType,
  Status,
} from '../../../../../logic/graphql/types/types.d';
import { Paths } from '../../../../../navigation/paths';
import { useIntl } from 'react-intl';

const ExchangeOrderListItem = (props: {
  listItem: ListItemDataInput;
  style?: React.CSSProperties | undefined;
  mobileHeight?: number;
}): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();
  const handleOnClick = (): void => {
    history.push(Paths.exchange_orders + '/' + props.listItem.id);
  };

  const value =
    props.listItem.type === ExchangeRateType.StopMarket
      ? (props.listItem.activation_price || 0) * props.listItem.count
      : (props.listItem.limit_price || 0) * props.listItem.count;

  const pricesDataLines = [
    {
      label: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.limitPrice' }),
      value: formatNumber(props.listItem.limit_price, props.listItem.security.currency.currency),
    },
    {
      label: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.activationPrice' }),
      value: formatNumber(
        props.listItem.activation_price,
        props.listItem.security.currency.currency,
      ),
    },
  ];

  if (props.listItem.status === Status.Completed || props.listItem.status === Status.Partial) {
    pricesDataLines.push({
      label: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.dealPrice' }),
      value: formatNumber(props.listItem.deal_price, props.listItem.security.currency.currency, 6),
    });
  }

  const data: ListItemData = {
    status: props.listItem.status,
    iconVisible: true,
    title: props.listItem.security.name,
    titleExtension: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.extensionLabel' }),
    transactionCode: props.listItem.transaction_code,
    detailBlocks: [
      {
        dataLines: [
          {
            label: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.valueLabel' }),
            value: formatNumber(value, props.listItem.security.currency.currency),
            variant: DataVariant.descriptive_highlighted,
          },

          {
            label: intl.formatMessage({ id: 'exchangeOrderListPage.listItem.countLabel' }),
            value: props.listItem.count.toString(),
            variant: DataVariant.gray,
          },
        ],
      },
      {
        dataLines: pricesDataLines,
      },
    ],
    date: props.listItem.validity_end
      ? formatDate(props.listItem.validity_start) + ' - ' + formatDate(props.listItem.validity_end)
      : intl.formatMessage({ id: 'exchangeOrderListPage.listItem.toCancellation' }),
    direction: props.listItem.direction,
  };

  return (
    <ListItem
      onClick={handleOnClick}
      data={data}
      style={props.style}
      mobileHeight={props.mobileHeight}
    />
  );
};

export default ExchangeOrderListItem;
